import http from '../../../plugins/axios';

export default {
    getUserBalanceSnapshot(data) {
        return http.get({
            url: '/admin/user/balance/snapshot',
            data
        })
    },
}
